// extracted by mini-css-extract-plugin
export default {"root":"JL95mMrB","main":"Marp13l7"};